import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
const styles = require('./index.less');

const TabMenu = ({ store, className }) => {
  store.use();

  return (
    <div className={cx(styles.tabRoot, className)}>
      <span className={styles.decoLine} style={{ '--x': `${store.x}px` }}>
        <i className={styles.iconArrowDown} style={{ '--x': `${store.x}px` }} />
      </span>
      <div ref={store.tabInnerRef} className={styles.tabInner}>
        {store.tabList.map((item, index) => {
          return (
            <div
              ref={c => (store.tabItemListRef.current[index] = c)}
              className={cx(styles.tabItem, {
                [styles.active]: index === store.activeIndex
              })}
              key={index}
              onClick={() => store.handleTabChange(index, item)}
            >
              {item.tab_title}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default wrapStore(TabMenu, Store);
